<template>
  <div class="audio-controls d-flex justify-content-center align-items-center">
    <BaseButton
      class="first-track-btn mr-16 reset-btn-styling"
      data-testid="firstTrackBtn"
      variant="naked"
      :disabled="disablePrevButtons"
      @click="goTo(0, isPlaying)"
    >
      <FirstIcon fill="white" width="15.25" height="12.78" />
    </BaseButton>

    <BaseButton
      class="rewind-btn mr-24 reset-btn-styling"
      data-testid="rewindBtn"
      variant="naked"
      :disabled="disablePrevButtons"
      @click="goTo(activeChapter.order - 2, isPlaying)"
    >
      <RewindIcon fill="white" width="17.06" height="9.64" />
    </BaseButton>

    <BaseButton
      v-if="!isPlaying || isLoading"
      variant="naked"
      :disabled="isLoading"
      data-testid="playBtn"
      :class="['play__btn reset-btn-styling', { loading: isLoading }]"
      @click="play"
    >
      <PlayIcon v-if="!isLoading" class="play__icon" />
    </BaseButton>

    <BaseButton
      v-else
      variant="naked"
      class="pause__btn reset-btn-styling"
      data-testid="pauseBtn"
      @click="pause"
    >
      <PauseIcon class="pause__icon" width="12px" height="15px" />
    </BaseButton>

    <BaseButton
      variant="naked"
      :disabled="disableNextButtons"
      class="fast-forward-btn ml-24 reset-btn-styling"
      data-testid="fastForwardBtn"
      @click="goTo(activeChapter.order, isPlaying)"
    >
      <FastForward fill="white" width="17.06" height="9.64" />
    </BaseButton>

    <BaseButton
      variant="naked"
      :disabled="disableNextButtons || !chapters.length"
      class="last-track-btn ml-16 reset-btn-styling"
      data-testid="lastTrackBtn"
      @click="goTo(chapters.length - 1, isPlaying)"
    >
      <LastIcon fill="white" width="15.25" height="12.78" />
    </BaseButton>
  </div>
</template>

<script>
import PlayIcon from '~/assets/icons/play.svg'
import PauseIcon from '~/assets/icons/pause.svg'
import FastForward from '~/assets/icons/fast-forward.svg'
import RewindIcon from '~/assets/icons/rewind.svg'
import LastIcon from '~/assets/icons/last.svg'
import FirstIcon from '~/assets/icons/first.svg'

export default {
  components: {
    PlayIcon,
    PauseIcon,
    FastForward,
    RewindIcon,
    LastIcon,
    FirstIcon,
  },
  props: {
    isPrevEnabled: {
      type: Boolean,
      default: false,
    },
    isNextEnabled: {
      type: Boolean,
      default: false,
    },
    isPlaying: {
      type: Boolean,
      default: false,
    },
    isLoading: {
      type: Boolean,
      default: false,
    },
    goTo: {
      type: Function,
      default: () => {},
    },
    play: {
      type: Function,
      default: () => {},
    },
    pause: {
      type: Function,
      default: () => {},
    },
    activeChapter: {
      type: Object,
      default: () => ({}),
    },
    chapters: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    disablePrevButtons() {
      return this.isLoading || !this.isPrevEnabled
    },
    disableNextButtons() {
      return this.isLoading || !this.isNextEnabled
    },
  },
}
</script>

<style lang="scss" scoped>
.audio-controls {
  margin-top: 8px;
}

.btn:disabled,
.btn.disabled {
  background: none;
  border: 0;

  svg {
    fill: $grey-02;
  }
}

.play__btn,
.pause__btn,
.btn.loading {
  height: 32px;
  width: 32px;
  padding: 8px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 50%;
  background-color: $black !important;

  &:hover {
    opacity: 0.8;
  }
}

.play__icon,
.pause__icon {
  fill: $white;
}

.play__btn {
  padding: 7px 6px 7px 9px;
}

.first-track-btn,
.rewind-btn,
.last-track-btn,
.fast-forward-btn {
  min-width: unset !important;
  padding: 0;
  border: none !important;
  outline: none !important;
  display: flex;
  flex-direction: column;
  justify-content: center;

  svg {
    fill: $black;
  }

  &:hover:not(:disabled) {
    svg {
      opacity: 0.7;
    }
  }

  &:disabled {
    fill: $mid-grey;
  }
}
</style>
